import { useEffect, useState, useRef } from "react";

export const CustomCursor = () => {
  const [mode, setMode] = useState("default");
  const dotRef = useRef(null);
  const posRef = useRef({ x: -100, y: -100 });
  const targetRef = useRef({ x: -100, y: -100 });

  useEffect(() => {
    const isTouch = window.matchMedia("(hover: none)").matches;
    if (isTouch) return;

    // Only hide the OS pointer once we know we are actually drawing a
    // replacement, so a failure here never leaves a visitor with no cursor.
    document.documentElement.classList.add("has-custom-cursor");

    const move = (e) => {
      targetRef.current = { x: e.clientX, y: e.clientY };
    };
    window.addEventListener("mousemove", move);

    let raf;
    const loop = () => {
      const dx = targetRef.current.x - posRef.current.x;
      const dy = targetRef.current.y - posRef.current.y;
      posRef.current.x += dx * 0.22;
      posRef.current.y += dy * 0.22;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${posRef.current.x}px, ${posRef.current.y}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      if (t) setMode(t.dataset.cursor);
      else setMode("default");
    };
    document.addEventListener("mouseover", over);

    return () => {
      document.documentElement.classList.remove("has-custom-cursor");
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={dotRef} className="custom-cursor" data-mode={mode} aria-hidden="true" />;
};
